import { stateToHTML } from 'draft-js-export-html'
import { ContentState, convertFromRaw, EditorState } from 'draft-js';

const isEmpty = value => value === undefined || value === null || value === ''; // eslint-disable-line
const join = (rules) => (value, data) => rules.map(rule => rule(value, data)).filter(error => !!error)[0]; // eslint-disable-line

export function email(value) { // eslint-disable-line
  // Let's not start a debate on email regex. This is just for an example app!
  if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return 'Invalid email address';
  }
}

export function required(value) { // eslint-disable-line
  if (isEmpty(value)) {
    return 'Required';
  }
}

export function minLength(min) {
  return (value) => { // eslint-disable-line
    if (!isEmpty(value) && value.length < min) {
      return `Must be at least ${min} characters`;
    }
  };
}

export function maxLength(max) {
  return value => { // eslint-disable-line
    if (!isEmpty(value) && value.length > max) {
      return `Must be no more than ${max} characters`;
    }
  };
}

export function integer(value) { // eslint-disable-line
  if (!Number.isInteger(Number(value))) {
    return 'Must be an integer';
  }
}

export function oneOf(enumeration) {
  return (value) => { // eslint-disable-line
    if (!~enumeration.indexOf(value)) { // eslint-disable-line
      return `Must be one of: ${enumeration.join(', ')}`;
    }
  };
}

export function match(field) {
  return (value, data) => { // eslint-disable-line
    if (data) {
      if (value !== data[field]) {
        return 'Do not match';
      }
    }
  };
}

export function phone(value) { // eslint-disable-line
  if (!/^(\d|\+)[0-9+() -]+$/.test(value)) {
    return 'Invalid phone format';
  }
}

export function createValidator(rules, section, activate) {
  return (data = {}) => {
    data = data.toJS ? data.toJS() : data; // eslint-disable-line
    data = section && data.section ? data[section] : data; // eslint-disable-line
    if (activate && typeof data[activate] !== 'undefined') {
      if (!data[activate]) {
        return {};
      }
    }
    const errors = {};
    Object.keys(rules).forEach((key) => {
      const rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
      const error = rule(data[key], data);
      if (error) {
        errors[key] = error;
      }
    });
    return errors;
  };
}

export const validateNullValues = (obj) => {
  if(obj === undefined || obj === null || typeof obj === 'undefined'){
    return false;
  }
  return true;
}

export const filterByAcervoActives = {
    query: {
        "bool": {
            "must": [
                {
                    "match": {
                        "valid": 1
                    }
                },
                {
                    "match": {
                        "id_status": 4
                    }
                }
            ]
        }
    }
}
const TITLE_FIELDS = ["titulo_original", "titulo_ingles", "titulo_otro_idioma"];
const LOGLINE_FIELD = "logline";

export const filterByAcervoActivesWithSearch = (value, props) => {
  const fields = props.dataField || [];
  const titleFields = fields.filter((field) => TITLE_FIELDS.includes(field));
  const hasLogline = fields.includes(LOGLINE_FIELD);
  const otherFields = fields.filter(
    (field) => !TITLE_FIELDS.includes(field) && field !== LOGLINE_FIELD
  );

  const searchClauses = value
    ? [
        ...titleFields.map((field) => ({
          match_phrase_prefix: { [field]: { query: value, boost: 15 } },
        })),
        titleFields.length && {
          multi_match: {
            query: value,
            fields: titleFields,
            type: "best_fields",
            operator: "or",
            minimum_should_match: "75%",
            fuzziness: "AUTO",
            boost: 8,
          },
        },
        hasLogline && {
          match_phrase_prefix: {
            [LOGLINE_FIELD]: {
              query: value,
              boost: 2,
            },
          },
        },
        otherFields.length && {
          multi_match: {
            query: value,
            fields: otherFields,
            type: "best_fields",
            operator: "or",
            minimum_should_match: "75%",
            fuzziness: "AUTO",
            boost: 1,
          },
        },
      ].filter(Boolean)
    : [];

  return {
    query: {
      bool: {
        must: [
          { match_phrase: { valid: "1" } },
          { match_phrase: { id_status: "4" } },
        ],
        ...(value ? { should: searchClauses, minimum_should_match: 1 } : {}),
      },
    },
  };
};

const isRaw = (obj) =>
  obj && typeof obj === 'object' &&
  Array.isArray(obj.blocks) &&
  typeof obj.entityMap === 'object';

export const editorStringify = (value) => {
  if (!value) return '';

  console.log("editorStringify", value)

  if (typeof value === 'string') {
    const t = value.trim();
    if (t.startsWith('<')) return t;

    try {
      const raw = JSON.parse(t);
      if (isRaw(raw)) return stateToHTML(convertFromRaw(raw));
    } catch (_) { }

    return stateToHTML(ContentState.createFromText(value));
  }

  if (value instanceof EditorState) {
    return stateToHTML(value.getCurrentContent());
  }

  if (value && typeof value.getBlockMap === 'function') {
    return stateToHTML(value);
  }

  if (isRaw(value)) {
    return stateToHTML(convertFromRaw(value));
  }

  return '';
};